module.exports = __webpack_public_path__ + "b5c864bd6ebb5e5ea004f741b2b03d48.png";